import React from "react";
import { Box, Typography } from "@mui/material";

const RoundedBox = ({ number = 68, color = "#f0f0f0", textColor = "#333",width = 50, height = 40,border='none' }) => {
  return (
    <Box
      sx={{
        width: `${width}px`,
        height: `${height}px`,
        backgroundColor: color,
        borderRadius: "6px",
        boxShadow: "inset 0 0 10px rgba(0, 0, 0, 0.3)", // <<< INNER shadow
        display: "flex",
        border:border,
        alignItems: "center",
        justifyContent: "center",
        color: textColor,
        fontWeight: "bold",
        fontSize: "1rem",
        margin: 0,
        padding: 0,
        // boxSizing:'border-box'
      }}
    >
      <Typography
        sx={{
          margin: 0,
          padding: 0,
          lineHeight: 1,
          fontSize: "1rem",
        }}
      >
        {number}
      </Typography>
    </Box>
  );
};

export default RoundedBox;
